import Track from '.';
import { fileFormat } from '../fileExtensions';
import Source from '../source';

export default class DropboxTrack extends Track {
  static from(file: DropboxTypes.files.FileMetadataReference) {
    return new DropboxTrack(file);
  }
  constructor(file: DropboxTypes.files.FileMetadataReference) {
    super(
      file.id, // we throw on null later in the constructor
      Source.Dropbox,
      // Remove filename extensions
      file.name.replace(/\.(?:.(?!\.))+$/, ''),
    );

    if (!file.id) throw new Error('Missing id for DropboxTrack');

    const format = fileFormat(file.name);
    if (format) this.format = format;
  }
}
